import DateTime from '@dealroadshow/uikit-date-time';
import type { ITimeZone } from '@dealroadshow/uikit-date-time';
import { FULL_DATE_FORMAT } from '@dealroadshow/uikit-date-time/dateFormats';
import { IAskAiChatMessage } from '@/creditflowresearch/domain/vo/AskAiChat';
import { findQuestionIndex, isInFlight } from '@/creditflowresearch/application/AskAiChat/helpers/chatMessages';

export interface IMessageGroup {
  label: string,
  messages: IAskAiChatMessage[],
}

const getDateLabel = (createdAt: string, timeZone: ITimeZone): string =>
  new DateTime(createdAt, { timeZone }).format(FULL_DATE_FORMAT);

export const isProcessingVisible = (message: IAskAiChatMessage): boolean => {
  if (!isInFlight(message)) return false;

  return !message.content || !!message.stage;
};

export const groupMessagesByDate = (
  messages: IAskAiChatMessage[],
  timeZone: ITimeZone,
): IMessageGroup[] => {
  const groups = new Map<string, IMessageGroup>();

  for (const message of messages) {
    const label = getDateLabel(message.createdAt, timeZone);
    const group = groups.get(label);

    if (group) {
      group.messages.push(message);
    } else {
      groups.set(label, { label, messages: [message] });
    }
  }

  return [...groups.values()];
};

export const getRequestContent = (messages: IAskAiChatMessage[], responseId: string): string | null => {
  const index = findQuestionIndex(messages, responseId);

  return index === -1 ? null : messages[index].content;
};
